import { render, staticRenderFns } from "./SaldosTarjetas.vue?vue&type=template&id=65764d32&scoped=true"
import script from "./SaldosTarjetas.vue?vue&type=script&lang=js"
export * from "./SaldosTarjetas.vue?vue&type=script&lang=js"
import style0 from "./SaldosTarjetas.vue?vue&type=style&index=0&id=65764d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65764d32",
  null
  
)

export default component.exports